import {
  Dialog,
  BUTTON_VARIANTS,
  IconStatusWarningExclamation,
} from 'cdk-radial';
import styled from 'styled-components';

export const StyledDialog = styled(Dialog)`
  min-width: 560px;
  max-width: 30%;
  margin-top: 60px;
  z-index: 9999;
  @media (max-width: 570px) {
    min-width: 10vw;
    max-width: 100%;
    width: 92vw;
  }
`;

export const StyledDialogTitle = styled.div`
  fontweight: 600;
  font-size: 1.25rem;
  line-height: 24px;
  @media (max-width: 570px) {
    font-size: 1.1rem;
  }
  @media (max-width: 510px) {
    font-size: 1rem;
  }
  @media (max-width: 490px) {
    font-size: .9rem;
  }
  @media (max-width: 450px) {
    font-size: .8rem;
  }
  @media (max-width: 400px) {
    font-size: .7rem;
  }
`;

export const StyledDialogTitleContainer = styled.div`
  flex-direction: row;
  display: flex;
  align-items: center;
`;

export const StyledDialogContentText = styled.div``;
export const StyledDriveText = styled.div`
  font-size: 1rem;
  padding-top: 10px;
`;

export const StyledExtAppsText = styled.div`
  font-size: .9rem;
  font-weight: 600;
`;

export const StyledIconAccountCircle = styled(IconStatusWarningExclamation)`
  fill: #fa9c19;
  height: 38px;
  width: 38px;
  margin-right: 5px;
`;

interface IValidationDialog {
  isOpen: boolean;
  onCancel: () => void;
  onValidationProceed: () => void;
}

const ValidationDialog = ({
  isOpen,
  onValidationProceed,
  onCancel,
}: IValidationDialog): JSX.Element => {

  return (
    <div>
      <StyledDialog
        buttonsProps={[
          {
            id: 'Cancel',
            dataTestId: 'logout-dialog-cancel',
            onClick: onCancel,
            text: 'Cancel',
            variant: BUTTON_VARIANTS.TEXT,
            },
          {
            id: 'logout-dialog-sign-out',
            onClick: onValidationProceed,
            text: 'Proceed',
            variant: BUTTON_VARIANTS.PRIMARY,
          },
        ]}
        id="logout-dialog-signout-alert"
        data-testid="logout-dialog-signout-alert"
        isOpen={isOpen}
        onClose={onCancel}
        title={
          <StyledDialogTitleContainer>
            <StyledIconAccountCircle />
            <StyledDialogTitle>
              Leave Page?
            </StyledDialogTitle>
          </StyledDialogTitleContainer>
        }
      >
          <StyledDriveText>
            Please save any unsaved changes before exiting the application.
          </StyledDriveText>
      </StyledDialog>
    </div>
  );
};
export default ValidationDialog;
